import { render, staticRenderFns } from "./RocketMQ.vue?vue&type=template&id=b07e9e8c&"
import script from "./RocketMQ.vue?vue&type=script&lang=js&"
export * from "./RocketMQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports